import React from "react";
import Icon, { IconName } from "../Icon/Icon.component";
import {
  IconBox,
  StepDescription,
  StepNumber,
  StepTitle,
  StepTop,
  StepWrapper,
} from "./StepCard.styled";

interface IStepCard {
  number: string;
  title: string;
  description: string;
  icon: IconName;
  accent: string;
}

const StepCard = ({ number, title, description, icon, accent }: IStepCard) => (
  <StepWrapper>
    <StepTop>
      <StepNumber>{number}</StepNumber>
      <IconBox accent={accent}>
        <Icon name={icon} />
      </IconBox>
    </StepTop>
    <StepTitle>{title}</StepTitle>
    <StepDescription>{description}</StepDescription>
  </StepWrapper>
);

export default StepCard;
